import "./App.css";
import { Routes, Route } from "react-router-dom";
import { ROTUES } from "./utils/global";
import Home from "./component/Home/Home";
import LoginPage from "./Pages/Auth/LoginPage";
import Dashboard from "./Pages/Dashboard";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TouchEdit from "./Pages/TouchEdit/TouchEdit";
import Admin from "./Pages/Admin";
import UserDetails from "./Pages/UserDetails";
import PrivateRoute from "./component/Auth/PrivateRoute";
import DownloadPdf from "./Pages/DownloadPdf";
import Loader from "./component/Partial/Loader";
import { useSelector } from "react-redux";
import Register from "./component/Auth/Register";
import AdminLogin from "./component/Auth/AdminLogin";
import UserTable from "./component/Admin/UserTable";
import ProjectsTable from "./component/Admin/ProjectTable";
import AdminDashboard from "./Pages/AdminDashboard";
import Profile from "./Pages/Profile";

function App() {
  const isLoading = useSelector((state) => state.project.isLoading);

  return (
    <div className="">
      <Routes>
        <Route path={ROTUES.login} element={<LoginPage />} />
        <Route path={ROTUES.register} element={<Register />} />
        <Route path={ROTUES.adminLogin} element={<AdminLogin />} />
        <Route
          path={ROTUES.home}
          element={<PrivateRoute children={<Home />} />}
        />
        <Route
          path={`${ROTUES.dashboard}/:id`}
          element={<PrivateRoute children={<Dashboard />} />}
        />
        <Route
          path={`${ROTUES.editTouch}/:id`}
          element={<PrivateRoute children={<TouchEdit />} />}
        />
        <Route
          path={`/admin`}
          element={<PrivateRoute role={["admin"]} children={<Admin />} />}
        >
          <Route path={"projects"} element={<ProjectsTable />} />
          <Route path={"users"} element={<UserTable />} />
          <Route path={"profile"} element={<Profile />} />

          {/* <Route path={"dashboard"} element={<AdminDashboard />} /> */}
        </Route>
        <Route
          path={`/admin/user/details/:id`}
          element={<PrivateRoute role={["admin"]} children={<UserDetails />} />}
        />
        <Route
          path={`${ROTUES.downloadPdf}/:id`}
          element={
            <PrivateRoute role={["admin", "user"]} children={<DownloadPdf />} />
          }
        />
      </Routes>
      <ToastContainer />
      {isLoading?.length ? <Loader /> : null}
    </div>
  );
}

export default App;
